import ErrorIcon from 'assets/icons/indicators/ErrorIcon';
import WarningIcon from 'assets/icons/indicators/WarningIcon';
import { ErrorMessage } from 'components/forms/FormComponents';
import strings from '../../../strings/strings.json';
import { FlexSmAlignCenter } from 'components/Elements';
import { MainSectionWithGaps } from 'components/sections/MainSection';
import Notification, { NotificationType } from 'components/notifiers/Notification';

export function CourseFullMessage() {
    return (
        <FlexSmAlignCenter>
            <ErrorIcon />
            <ErrorMessage $bold>{strings.publicCoursePage.errors.courseCancelledError.description}</ErrorMessage>
        </FlexSmAlignCenter>
    );
}

export function CourseCancelledMessage() {
    return (
        <FlexSmAlignCenter>
            <WarningIcon />
            <ErrorMessage $bold>{strings.publicCoursePage.errors.courseFullError.description}</ErrorMessage>
        </FlexSmAlignCenter>
    );
}

export function CourseNotFoundError() {
    return (
        <MainSectionWithGaps>
            <Notification
                notificationType={NotificationType.DANGER}
                title={strings.publicCoursePage.errors.courseNotFoundError.title}
                description={strings.publicCoursePage.errors.courseNotFoundError.description}
                maxWidth="1240"
            />
        </MainSectionWithGaps>
    );
}
